import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Form, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { validation, formValues } from './validationSchema';

import { useDispatch, useSelector } from 'react-redux';
import { editEvidenceList, getEvidenceList } from '../../store/actions/evidenceList';

import { errorHelper, Loader } from '../../utils/tools';
import { activityCodeDescriptions } from '../../utils/constants/activityCodes';
import { loadingCodes } from '../../utils/constants/loadingCodes';

import WasteCodeInput from './wasteCodeInput';

const EditEvidenceList = ({evidenceList, onClose, currentBranch}) => {

    const currentEvidenceList = useSelector(state => state.evidenceList.current)
    const currentEvidenceListLoading = useSelector(state => state.evidenceList.currentLoading);

    const evidenceListId = evidenceList;

    let navigate = useNavigate();

    // Redux logic
    const notifications = useSelector(state => state.notifications);
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...formValues,
            name: currentEvidenceList?.name || '',
            activityCode: currentEvidenceList?.activityCode || '',
            yCode: currentEvidenceList?.yCode || '',
            wasteCodeId: currentEvidenceList?.wasteCode?._id || '',
            includedInReport: currentEvidenceList?.includedInReport !== undefined ? currentEvidenceList.includedInReport : true,
            primaryLoadingCode: currentEvidenceList?.primaryLoadingCode || '',
        },
        validationSchema: validation,
        onSubmit: (values) => {
            handleSubmit(values)
        }
    })

    useEffect(() => {
        if (currentBranch !== '' && evidenceListId !== '') {
        
            const id = evidenceListId._id;

            dispatch(getEvidenceList({ id, currentBranch }))
                .then(response => {
                    if (response.error) {
                        console.error(response.error);
                    }
                })
        }
    }, [dispatch, evidenceListId]);

    const handleSubmit = (values) => {
        if(currentBranch !== '')
            values.branchId = currentBranch;
            values.evidenceSheetId = evidenceListId;
            dispatch(editEvidenceList(values));
    }

    useEffect(()=>{
        if(notifications && notifications.global.success){
            onClose();
        }
    },[notifications, navigate]);

    return (
        <>
            <div className='auth_container'>
                <h2>Upraviť evidenčný list</h2>
                <hr />

                {  currentEvidenceListLoading || !currentEvidenceList ?
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '75vh' 
                    }}>
                        <Loader />
                    </div>
                : 
                        <Form
                            component="form"
                            onSubmit={formik.handleSubmit}
                            id="editEvidenceListForm"
                        >
                            <Row>
                                {/* Name */}
                                <Form.Group className="mb-3" controlId="formBasicName">
                                    <Form.Label>Názov evidenčného listu*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Zadajte názov evidenčného listu:"
                                        {...formik.getFieldProps('name')}
                                        isInvalid={errorHelper(formik, 'name').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'name').helperText} 
                                    </Form.Control.Feedback>
                                </Form.Group>
                                
                                {/* Activity Code */}
                                <Form.Group className="mb-3" controlId="formBasicActivityCode">
                                    <Form.Label>Kód činnosti*</Form.Label>
                                    <Form.Select
                                        aria-label="Vyberte kód činnosti"
                                        {...formik.getFieldProps('activityCode')}
                                        isInvalid={errorHelper(formik, 'activityCode').error}
                                    >
                                       
                                        <option value="">Vyberte kód činnosti:</option>
                                        {Object.entries(activityCodeDescriptions).map(([code, description]) => (
                                            <option key={code} value={code}>
                                                {code} - {description}
                                            </option>
                                        ))}

                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'activityCode').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* Primary Loading Code - shown only for activity code R */}
                                {formik.values.activityCode === 'R' && (
                                    <Form.Group className="mb-3" controlId="formBasicPrimaryLoadingCode">
                                        <Form.Label>Hlavný kód nakladania*</Form.Label>
                                        <Form.Select
                                            aria-label="Vyberte hlavný kód nakladania"
                                            {...formik.getFieldProps('primaryLoadingCode')}
                                            isInvalid={errorHelper(formik, 'primaryLoadingCode').error}
                                        >
                                            <option value="">Vyberte hlavný kód nakladania:</option>
                                            {loadingCodes['Zhodnocovanie odpadu']
                                                .filter(c => !['R12', 'R13'].includes(c.value))
                                                .map(c => (
                                                    <option key={c.value} value={c.value}>{c.value} - {c.label}</option>
                                                ))
                                            }
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errorHelper(formik, 'primaryLoadingCode').helperText}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                )}

                                {/* Waste Code */}
                                <WasteCodeInput
                                    values={formik.values}
                                    setFieldValue={formik.setFieldValue}
                                    setFieldTouched={formik.setFieldTouched}
                                    touched={formik.touched}
                                    errors={formik.errors}
                                />

                                {/* Included in report */}
                                <Form.Group className="mb-3 mt-2" controlId="formIncludedInReport">
                                    <Form.Check
                                        type="switch"
                                        id="includedInReport"
                                        label="Zahrnutý do ohlásenia odpadov"
                                        checked={formik.values.includedInReport}
                                        onChange={(e) => formik.setFieldValue('includedInReport', e.target.checked)}
                                    />
                                </Form.Group>

                            </Row>

                            <Row className="mt-3">
                                <hr />
                                <Col className="d-flex justify-content-end">
                                    <Button
                                        className='button-custom-large'
                                        variant='primary'
                                        type="submit"
                                        size="lg"
                                    >
                                        Upraviť evidenčný list
                                    </Button>
                                </Col>
                            </Row>
                        </Form>

                }
            </div>
        </>
    )
}

export default EditEvidenceList;